const LogConfig = {
    enabled: true,  //process.env.NODE_ENV !== 'production', // Disable in production
    Error: true,
    LogError: true,
    LogInsideAPI: false,
    LogRefreshCalls: false,
    LogCallsToAPI: false,
    LogResponseFromAPI: false,
    LogComponentUpdates: false,
    LogVersionUpdates: false,
    LogAuth: true,
    LogVerbose: false,
    LogIssue: true,
    LogSpecificTarget: true
};

//export default LogConfig;
module.exports = LogConfig;

